import React from "react";

const SearchButton = () => (
  <button className="search-header__search-button">Найти билеты</button>
);

export default SearchButton;
